export class SC_Originator {
    static readonly NULL = 0;
    static readonly MANUAL = 1;
    static readonly SERVICE_CHANNEL = 2;
    static readonly FM_PILOT = 4;

    constructor(private service: number = SC_Originator.NULL) { }

    static fromAPI(apiValue: number): SC_Originator {
        switch (apiValue) {
            case SC_Originator.MANUAL:
                return new SC_Originator(SC_Originator.MANUAL);
            case SC_Originator.SERVICE_CHANNEL:
                return new SC_Originator(SC_Originator.SERVICE_CHANNEL);
            case SC_Originator.FM_PILOT:
                return new SC_Originator(SC_Originator.FM_PILOT);
            default:
                return new SC_Originator();
        }
    }

    is(type: number): boolean {
        return this.service === type;
    }

    toAPI(): number {
        return this.service;
    }

    clone(): SC_Originator {
        return new SC_Originator(this.service);
    }

    /**
     * Merges another SC_Originator object into this one, replacing null fields
     */
    merge(other: SC_Originator): SC_Originator {
        if (other.service !== SC_Originator.NULL) {
            this.service = other.service;
        }

        return this;
    }

    static readonly originator = [
        { key: SC_Originator.MANUAL, display: "Manual" },
        { key: SC_Originator.SERVICE_CHANNEL, display: "Service Channel" },
        { key: SC_Originator.FM_PILOT, display: "FM Pilot" },
    ];

    is_external(): boolean {
        return this.service === SC_Originator.FM_PILOT || this.service === SC_Originator.SERVICE_CHANNEL;
    }

    toString(): string {
        switch (this.service) {
            case SC_Originator.FM_PILOT:
                return "FM Pilot";
            case SC_Originator.SERVICE_CHANNEL:
                return "Service Channel";
            case SC_Originator.MANUAL:
                return "Manual";
            default:
                return "UNKNOWN";
        }
    }
}
